/** HTTP-Statuscodes (RFC 9110), die das Frontend auswertet. */
export const HttpStatus = {
  NoContent: 204,
  BadRequest: 400,
  Unauthorized: 401,
  Forbidden: 403,
  NotFound: 404,
  Conflict: 409,
  TooManyRequests: 429,
  InternalServerError: 500,
  ServiceUnavailable: 503,
} as const;

/** HTTP-Methoden in der Schreibweise des Fetch-Standards. */
export const HttpMethod = {
  Get: "GET",
  Head: "HEAD",
} as const;
